import { db, auth, storage } from '@/plugins/firebase';
import firebase from 'firebase';
import 'firebase/app';
import { bus } from '@/main';

var beginningDate = Date.now() - 172800000;
var beginningDateObject = new Date(beginningDate);

export async function getContent({ commit }, { type, collection, mutation }) {
  return new Promise((resolve, reject) => {
    var dataArr = [];
    commit(mutation, dataArr);

    if (type === 'campaign') {
      db.collection(collection)
        .get()
        .then(async function(docs) {
          if (docs.empty) {
            return;
          }

          for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
          }

          commit(mutation, dataArr);
          resolve();
        })
        .catch((error) => reject(error));
    } else {
      db.collection(collection)
        .where('type', '==', type)
        .get()
        .then(async function(docs) {
          if (docs.empty) {
            return;
          }

          for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
          }

          commit(mutation, dataArr);
          resolve();
        })
        .catch((error) => reject(error));
    }
  });
}

export async function getStreamByRegion({ commit }, { collection, region }) {
  var dataArr = [];

  switch (collection) {
    case 'datastream':
      commit('updateDataStream', dataArr);
      await db
        .collection(collection)
        .where('state', '==', 'in-review')
        .where('state', '!=', 'deleted')
        .orderBy('state')
        .orderBy('createdAt', 'desc')
        .get()
        .then(async function(docs) {
          if (docs.empty) {
            return;
          }

          for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
          }

          commit('updateDataStream', dataArr);
        });
      break;
    case 'crawlerstream':
      commit('updateChatStream', dataArr);
      console.log('getting Chat Stream ', collection);
      await db
        .collection(collection)
        .where('createdAt', '>', beginningDateObject)
        .orderBy('createdAt', 'desc')
        .where('from', 'array-contains-any', ['ig-crawler'])
        .where('state', '==', 'in-review')
        .where('region.name', '==', region.name)
        .get()
        .then(async function(docs) {
          if (docs.empty) {
            return;
          }

          for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
          }

          commit('updateChatStream', dataArr);
        });
      break;
  }
}

export async function getStream({ commit }, { collection }) {
  var dataArr = [];

  switch (collection) {
    case 'datastream':
      commit('updateDataStream', dataArr);
      await db
        .collection(collection)
        .where('state', '==', 'in-review')
        .where('state', '!=', 'deleted')
        .orderBy('state')
        .orderBy('createdAt', 'desc')
        .get()
        .then(async function(docs) {
          if (docs.empty) {
            return;
          }

          for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
          }

          commit('updateDataStream', dataArr);
        });
      break;
    case 'crawlerstream':
      commit('updateChatStream', dataArr);

      await db
        .collection(collection)
        .where('createdAt', '>', beginningDateObject)
        .orderBy('createdAt', 'desc')
        .where('from', 'array-contains-any', ['ig-crawler'])
        .where('state', '==', 'in-review')
        .get()
        .then(async function(docs) {
          if (docs.empty) {
            return;
          }

          for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
          }

          commit('updateChatStream', dataArr);
        });
      break;
  }
}

export async function getDataStream({ commit }) {
  var dataArr = [];
  commit('updateDataStream', dataArr);

  await db
    .collection('datastream')
    .where('createdAt', '>', beginningDateObject)
    .orderBy('createdAt', 'desc')
    .where('state', '==', 'in-review')
    .get()
    .then(async function(docs) {
      if (docs.empty) {
        return;
      }

      for (var i = 0; i < docs.size; i += 1) {
        var doc = docs.docs[i];
        dataArr.push(doc.data());
      }

      commit('updateDataStream', dataArr);
    });
}

export async function getStreamByFrom(
  { commit },
  { collection, mutation, from },
) {
  var dataArr = [];
  commit(mutation, dataArr);

  await db
    .collection(collection)
    .where('createdAt', '>', beginningDateObject)
    .orderBy('createdAt', 'desc')
    .where('state', '==', 'in-review')
    .where('from', '==', from)
    .get()
    .then(async function(docs) {
      if (docs.empty) {
        return;
      }

      for (var i = 0; i < docs.size; i += 1) {
        var doc = docs.docs[i];
        dataArr.push(doc.data());
      }

      commit(mutation, dataArr);
    });
}

export async function updateStreamItem({ commit }, { details, collection }) {
  return new Promise((resolve, reject) => {
    console.log('updating data stream Item: ', details);

    const refObj = {
      ...details,
      updatedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    db.collection(collection)
      .doc(details.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit('show-snackbar', {
          text: collection + ' item' + ' updated!',
          color: 'success',
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit('show-snackbar', { text: err, color: 'error' });
        reject();
      });
  });
}

export async function deleteStreamItem({ commit }, { details, collection }) {
  return new Promise((resolve, reject) => {
    console.log('updating data stream Item: ', details);
    details.state = 'deleted';

    const refObj = {
      ...details,
      deletedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    db.collection(collection)
      .doc(details.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit('show-snackbar', {
          text: collection + ' Item' + ' deleted!',
          color: 'success',
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit('show-snackbar', { text: err, color: 'error' });
        reject();
      });
  });
}

export async function deleteDataStreamItem({ commit }, { details }) {
  return new Promise((resolve, reject) => {
    console.log('updating data stream Item: ', details);
    details.state = 'deleted';

    const refObj = {
      ...details,
      deletedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    db.collection('datastream')
      .doc(details.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit('show-snackbar', {
          text: 'Datastream Item' + ' deleted!',
          color: 'success',
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit('show-snackbar', { text: err, color: 'error' });
        reject();
      });
  });
}

export async function getContentByEntity(
  { commit },
  { type, collection, mutation, entity },
) {
  var dataArr = [];
  commit(mutation, dataArr);
  console.log('Hello Entity: ', entity);

  if (type === 'campaign') {
    await db
      .collection(collection)
      .where('pinData.entity.id', '==', entity.id)
      .get()
      .then(async function(docs) {
        if (docs.empty) {
          return;
        }

        for (var i = 0; i < docs.size; i += 1) {
          var doc = docs.docs[i];
          dataArr.push(doc.data());
        }

        commit(mutation, dataArr);
      });
  } else {
    await db
      .collection(collection)
      .where('type', '==', type)
      .where('entity.id', '==', entity.id)
      .get()
      .then(async function(docs) {
        if (docs.empty) {
          return;
        }

        for (var i = 0; i < docs.size; i += 1) {
          var doc = docs.docs[i];
          dataArr.push(doc.data());
        }

        commit(mutation, dataArr);
      });
  }
}

export async function getContentByEntityByState(
  { commit },
  { type, collection, mutation, entity, state },
) {
  var dataArr = [];
  commit(mutation, dataArr);
  console.log('Hello Entity: ', entity, type, state, collection);

  if (type === 'campaign') {
    await db
      .collection(collection)
      .where('pinData.entity.id', '==', entity.id)
      .where('state', '==', state)
      .get()
      .then(async function(docs) {
        if (docs.empty) {
          return;
        }

        for (var i = 0; i < docs.size; i += 1) {
          var doc = docs.docs[i];
          dataArr.push(doc.data());
        }

        commit(mutation, dataArr);
      });
  } else {
    await db
      .collection(collection)
      .where('type', '==', type)
      .where('entity.id', '==', entity.id)
      .where('state', '==', state)
      .get()
      .then(async function(docs) {
        if (docs.empty) {
          return;
        }

        for (var i = 0; i < docs.size; i += 1) {
          var doc = docs.docs[i];
          dataArr.push(doc.data());
        }

        commit(mutation, dataArr);
      });
  }
}

export async function getContentByRegionByState(
  { commit },
  { type, collection, mutation, region, state },
) {
  var dataArr = [];
  commit(mutation, dataArr);

  if (type === 'campaign') {
    await db
      .collection(collection)
      .where('pinData.region.id', '==', region.id)
      .where('state', '==', state)
      .get()
      .then(async function(docs) {
        if (docs.empty) {
          return;
        }

        for (var i = 0; i < docs.size; i += 1) {
          var doc = docs.docs[i];
          dataArr.push(doc.data());
        }

        commit(mutation, dataArr);
      });
  } else {
    await db
      .collection(collection)
      .where('type', '==', type)
      .where('region.id', '==', region.id)
      .where('state', '==', state)
      .get()
      .then(async function(docs) {
        if (docs.empty) {
          return;
        }

        for (var i = 0; i < docs.size; i += 1) {
          var doc = docs.docs[i];
          dataArr.push(doc.data());
        }

        commit(mutation, dataArr);
      });
  }
}

export async function getContentByRegion(
  { commit },
  { type, collection, mutation, region },
) {
  var dataArr = [];
  commit(mutation, dataArr);

  if (type == 'campaign') {
    await db
      .collection(collection)
      .where('pinData.region.id', '==', region.id)
      .where('state', '!=', 'deleted')
      .get()
      .then(async function(docs) {
        if (docs.empty) {
          return;
        }

        for (var i = 0; i < docs.size; i += 1) {
          var doc = docs.docs[i];

          dataArr.push(doc.data());
        }

        commit(mutation, dataArr);
      });
  } else {
    await db
      .collection(collection)
      .where('type', '==', type)
      .where('region.id', '==', region.id)
      .where('state', '!=', 'deleted')
      .get()
      .then(async function(docs) {
        if (docs.empty) {
          return;
        }

        for (var i = 0; i < docs.size; i += 1) {
          var doc = docs.docs[i];
          dataArr.push(doc.data());
        }

        commit(mutation, dataArr);
      });
  }
}

export async function createNewContent(
  { commit },
  { details, collection, type },
) {
  return new Promise((resolve, reject) => {
    const ref = db.collection(collection).doc();

    const refObject = {
      id: ref.id,
      ...details,
      createdBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    ref
      .set(refObject)
      .then(() => {
        console.log('Created new Content');
        bus.$emit('show-snackbar', {
          text: 'New ' + type + ' Created!',
          color: 'success',
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit('show-snackbar', { text: err, color: 'error' });
        reject();
      });
  });
}

export async function createNewAsset({ commit }, { details }) {
  return new Promise((resolve, reject) => {
    const assetRef = db.collection('assets').doc();

    const asset = {
      id: assetRef.id,
      ...details,
      state: 'active',
      createdBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    assetRef
      .set(asset)
      .then(() => {
        console.log('Created new Asset');
        bus.$emit('show-snackbar', {
          text: 'New Asset Created!',
          color: 'success',
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit('show-snackbar', { text: err, color: 'error' });
        reject();
      });
  });
}

export async function uploadImage({ commit, dispatch }, { image, entity }) {
  commit('updateUploadProgress', 0);
  return new Promise((resolve, reject) => {
    function randomStr(len, arr) {
      var ans = '';
      for (var i = len; i > 0; i--) {
        ans += arr[Math.floor(Math.random() * arr.length)];
      }
      return ans;
    }

    console.log(image);
    const fileName = randomStr(20, '123456789abcdefghijklmnopqrstuvqxyz');

    const ref = storage.ref(fileName).put(image);

    ref.on(
      `state_changed`,
      (snapshot) => {
        commit(
          'updateUploadProgress',
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        );
      },
      (error) => {
        console.log(error.message);
        reject(error.message);
      },
      () => {
        ref.snapshot.ref.getDownloadURL().then((downloadUrl) => {
          if (entity) {
            var asset = {
              entity: entity,
              image: {
                firebaseUrl: downloadUrl,
                url: `https://deetz-biscuit.imgix.net/${fileName}?ar=1%3A1&fit=crop&auto=compress&h=700`,
                thumbnail: `https://deetz-biscuit.imgix.net/${fileName}?ar=1%3A1&fit=crop&auto=compress&h=70`,
              },
            };

            dispatch('createNewAsset', { details: asset });
          }

          resolve({ firebaseUrl: downloadUrl, fileName });
          commit('updateUploadProgress', 0);
        });
      },
    );
  });
}

export async function updateContent({ commit }, { details, collection, type }) {
  return new Promise((resolve, reject) => {
    console.log('updating pin: ', details);
    if (details.state === 'scheduled') {
      details.state = 'scheduled';
    }

    if (details.state === 'active' || details.state === 'expired') {
      details.state = 'updated';
    }

    const refObj = {
      ...details,
      updatedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    db.collection(collection)
      .doc(details.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit('show-snackbar', {
          text: type + ' updated!',
          color: 'success',
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit('show-snackbar', { text: err, color: 'error' });
        reject();
      });
  });
}

export async function deleteContent({ commit }, { details, collection, type }) {
  return new Promise((resolve, reject) => {
    console.log('updating pin: ', details);

    const refObj = {
      ...details,
      deletedBy: {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
      },
      deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };

    db.collection(collection)
      .doc(details.id)
      .set(refObj, { merge: true })
      .then(() => {
        bus.$emit('show-snackbar', {
          text: type + ' Successfully Deleted!',
          color: 'success',
        });
        resolve();
      })
      .catch((err) => {
        bus.$emit('show-snackbar', { text: err, color: 'error' });
        reject();
      });
  });

  // console.log("Pin To Delete: ", details)
  // return new Promise((resolve, reject) => {
  //     db.collection(collection).doc(details.id).delete().then(function () {
  //         bus.$emit("show-snackbar", { text: type + " Successfully Deleted!", color: "success" });
  //         resolve()
  //     }).catch(function (error) {
  //         bus.$emit("show-snackbar", { text: error, color: "error" });
  //         reject()
  //     });
  // })
}
